import { render } from "./LecheCaliente.vue?vue&type=template&id=37063586"
import script from "./LecheCaliente.vue?vue&type=script&lang=js"
export * from "./LecheCaliente.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/AccesoGanaderos/Calidad/LecheCaliente.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37063586"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37063586', __exports__)) {
    api.reload('37063586', __exports__)
  }
  
  module.hot.accept("./LecheCaliente.vue?vue&type=template&id=37063586", () => {
    api.rerender('37063586', render)
  })

}


export default __exports__